import React from "react";
import HeadImg from "../../../assets/Exactness/Header/Bg.svg";
import Img1 from "../../../assets/exactness_main_illustration.png";

const Header = () => {
  const handlenav = () => {
    window.location.href = process.env.REACT_APP_BASE_URL;
  };

  return (
    <div className="relative flex flex-col">
      <img
        src={HeadImg}
        alt="Header Background"
        className="absolute top-0 left-0 w-full h-[80vh] object-cover"
      />

      <div className="flex flex-col items-center justify-center pt-14 relative z-10">
        <div className="text-center max-w-5xl px-8 md:px-10 lg:px-10">
          <p className="text-xl text-[1.7rem] font-medium leading-[1.67] text-gray-700">
            Email Precision You Can Trust.
          </p>
          <h1 className="text-3xl md:text-[42px] font-semibold text-center mt-2 !leading-[1.25]">
            Get 98% Valid Emails for Better Outreach!
          </h1>
          <div className="text-center w-full flex justify-center mt-5 md:mt-10 mb-4">
            <button
              onClick={handlenav}
              className="text-white font-semibold p-3 rounded-md bg-background hover:bg-hover hover:text-white w-[220px]"
            >
              Get Verified Emails
            </button>
          </div>
          <p className="text-[13.5px] text-gray-400 mt-3">
            Find your perfect plan with easy sign-up.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center mt-24 md:mt-2 relative px-10">
        <div className="flex justify-center items-center z-20">
          <img
            src={Img1}
            alt="Stats panel"
            className="w-24 h-24 min-[350px]:w-28 min-[350px]:h-28 min-[400px]:w-32 min-[400px]:h-32 min-[450px]:w-36 min-[450px]:h-36 min-[500px]:w-40 min-[500px]:h-40 min-[550px]:w-44 min-[550px]:h-44 min-[600px]:w-48 min-[600px]:h-48 md:w-auto md:h-auto"
          />
        </div>
      </div>

      <div className="flex flex-col items-center">
        <div className="text-center w-full flex justify-center mt-20 md:mt-6 px-4 max-w-md">
          <p className="text-[13.5px] text-gray-400 mt-3">
            Find emails that actually work. Quick, accurate, and reliable for
            your business outreach.
          </p>
        </div>
      </div>
      <div className="lg:max-w-5xl mx-auto p-4 my-6">
        <div className="grid grid-cols-1 min-[500px]:grid-cols-2 md:grid-cols-3 gap-6">
          <div className="py-8 px-12 whitespace-nowrap bg-white shadow-lg rounded-lg text-center transition-all duration-300 hover:shadow-xl flex flex-col justify-center">
            <h2 className="text-3xl font-bold text-gray-800">
              Up to <span className="text-[#4f7fff]">51%</span>
            </h2>
            <p className="text-gray-500 mt-1.5">Email Discovery</p>
          </div>

          <div className="py-8 px-12 whitespace-nowrap bg-white shadow-lg rounded-lg text-center transition-all duration-300 hover:shadow-xl flex flex-col justify-center">
            <h2 className="text-3xl font-bold text-[#4f7fff]">99%</h2>
            <p className="text-gray-500 mt-1.5">Email accuracy</p>
          </div>

          <div className="py-8 px-12 whitespace-nowrap bg-white shadow-lg rounded-lg text-center transition-all duration-300 hover:shadow-xl flex flex-col justify-center min-[500px]:col-span-2 md:col-auto">
            <h2 className="text-3xl font-bold text-gray-800">
              <span className="text-[#4f7fff]">150K</span> Rows
            </h2>
            <p className="text-gray-500 mt-1.5">Bulk Processing</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
